require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// ./~/@xlts.dev/angular-sanitize/index.js
// module id = 446
// module chunks = 0